import React from 'react';

import type { ChangeEvent } from 'react';

import { Box, TextField, Typography } from '@mui/material';

type ColorPickerProps = Readonly<{
  value: string;
  onChange: (color: string) => void;
  label?: string;
  disabled?: boolean;
}>;

export const ColorPicker = ({
  value,
  onChange,
  label = 'Color',
  disabled = false
}: ColorPickerProps) => {
  const handleColorChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  const handleTextInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const inputValue = event.target.value;
    if (/^#[0-9A-Fa-f]{6}$/.test(inputValue)) {
      onChange(inputValue);
    }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      <Typography variant="caption" sx={{ fontWeight: 600 }}>
        {label}
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <TextField
          type="color"
          value={value}
          onChange={handleColorChange}
          disabled={disabled}
          size="small"
          sx={{
            width: 40,
            height: 32,
            '& .MuiInputBase-input': {
              padding: '4px 8px',
              cursor: disabled ? 'not-allowed' : 'pointer'
            }
          }}
        />
        <TextField
          type="text"
          value={value}
          onChange={handleTextInputChange}
          disabled={disabled}
          size="small"
          sx={{ width: 80 }}
          placeholder="#000000"
        />
      </Box>
    </Box>
  );
};
